import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";

import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { Create_States, Delete_States, Edit_States, GetStatesById } from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddStateMaster = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "State Master");
  const Form_Key = "State_Master";
  const [isFirstLoad, setFirstLoad] = useState(false);
  const { pushModal, popModal } = useModalContext();
  const formRef = useRef({});
  const [FormData, setFormdata] = useState<any>({});
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.State_Master?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});


  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: Createstates }] = useMutation(Create_States);

  const [GetCityesByID, { loading: GetCityesByIDLoader }] = useLazyQuery(GetStatesById, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: Editstates }] = useMutation(Edit_States, {
    fetchPolicy: "network-only",
  });

  const [DeletingData, { loading: Deletestates }] = useMutation(Delete_States);

  const CityLoading = Createstates || Editstates || Deletestates || GetCityesByIDLoader;

  console.log("CityLoadingCityLoadingCityLoading", FormData, FormDataFromRedux);

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };


  // Handle errors received from FormInputSectionComponent
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    setSelectedRows(fielddataRedux?.State_Master?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      getFormSectionAndFields().then(() => {
        GetCityesByID({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let StateData = { ...data?.State?.[0] };
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Country: { _id: StateData?.Country?._id },
                Zone: { _id: StateData?.Zone?._id },
              },
            },
          });
          if (StateData && StateData.Country) {
            StateData.Country = StateData?.Country?.Country;
          }
          if (StateData && StateData.Zone) {
            StateData.Zone = StateData?.Zone?.Zone;
          }
          setAllFieldsData(StateData);
          updateValueForm(formRef, StateData);
        });
      });
    }
  }, [fielddata]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);


  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, FormData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction: string) => {
    FormData.Country = FormDataFromRedux?.MasterData[Form_Key]?.Country?._id;
    FormData.Zone = FormDataFromRedux?.MasterData[Form_Key]?.Zone?._id;
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: FormData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => {
        if (operationType === "Edit" || operationType === "Delete") {
          dispatch({ type: "Refetch", payload: true });
        }
      },
      onError: (error: any) => {
        ErrorToast((error as Error).message);
      },
    });
  };

  const Closeformfunction = () => {

    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    // dispatch({ type: "ClearData", payload: { data: {} } });
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };



  if (TypeOfPortal === "Delete State Master" || modifiedTypeOfPortal === "Delete State Master") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"} id={""}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={CityLoading}
        />
      </Reactportal>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
   
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
            Validate_handleSubmit(SaveAndCloseForAdd);
          }
          : () => {
            Validate_handleSubmit(submit);
          }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={CityLoading}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
          id={""}
        >
          <>
            {CityLoading && <div className="loader-line-div" />}
            <div className="formContainer">
              {inputFields && inputFields?.length > 0 ? (
                inputFields.map((e, i) => (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        onErrorsChange={handleErrorsChange}
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                        setFirstLoad={setFirstLoad}
                      />
                    </div>
                  </div>
                ))
              ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                <p>No form fields available.</p>
              ) : null}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddStateMaster;
